export default __webpack_public_path__ + "static/media/img3.a6ccdd9c.png";